const Constante = {
	"messageSucc":"Un courriel de changement de mot de passe vous a été envoyé",
	"messageErr":"Email inconnu",
	"classSuccess":"alert alert-success text-center",
	"classError":"alert alert-danger text-center",
	"userExiste":"Votre compte est déjà inscrit ! Pour vous connecter à votre compte, choisissez 'Connexion'."
}

export default Constante;